import { render, staticRenderFns } from "./BestSellers.vue?vue&type=template&id=40151602&"
import script from "./BestSellers.vue?vue&type=script&lang=js&"
export * from "./BestSellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports